import { isDefined } from '@sgme/fp';
import { DocumentError } from 'apiConnector/document/document';
import { DocumentItem, PublicDocumentItem } from 'epic/common-form/Documentation';
import { useDownloadDlpDocument } from 'hooks/useDownloadDlpDocument';
import { useDownloadTermsheet } from 'hooks/useDownloadTermsheet';
import { useTranslation } from 'hooks/useTranslation';
import { IBlotterItem } from 'models/IBlotterItem';
import { useCallback } from 'react';

export function useTermsheetDownload(blotterItem: IBlotterItem) {
  const { isDownloading: isDownloadingTermsheet, downloadTermsheet, error: errorTermsheet } = useDownloadTermsheet();
  const downloadTermsheetErrorMessage = useTranslation('downloadTermsheet.error');
  const {
    isDownloading: isDownloadingDlpDocument,
    downloadDlpDocument,
    error: errorDlp,
  } = useDownloadDlpDocument(downloadTermsheetErrorMessage);

  const onTermsheetDownload = useCallback(
    (doc: DocumentItem) => {
      if (doc.public === false) {
        downloadDlpDocument(doc.documentToken!);
      } else {
        if (isDefined((doc as PublicDocumentItem).url)) {
          return;
        }
        downloadTermsheet(blotterItem.productId, blotterItem, doc.language);
      }
    },
    [blotterItem, downloadTermsheet, downloadDlpDocument],
  );

  const hasError = errorTermsheet !== null || errorDlp !== null;

  return {
    onTermsheetDownload,
    isTermsheetDownloading: isDownloadingTermsheet || isDownloadingDlpDocument,
    error: hasError
      ? (errorTermsheet ?? ({ type: 'END_USER_ERROR', errorMessages: [errorDlp!] } satisfies DocumentError))
      : undefined,
  };
}
